import { render, staticRenderFns } from "./ComboItemExperimental.vue?vue&type=template&id=ecb7808e&scoped=true&"
import script from "./ComboItemExperimental.vue?vue&type=script&lang=js&"
export * from "./ComboItemExperimental.vue?vue&type=script&lang=js&"
import style0 from "./ComboItemExperimental.vue?vue&type=style&index=0&id=ecb7808e&prod&scoped=true&lang=css&"
import style1 from "./ComboItemExperimental.vue?vue&type=style&index=1&id=ecb7808e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb7808e",
  null
  
)

export default component.exports